import type { ObjectValuesAsTypes } from "utils/types";

export const SCA_LOGIN_ERROR_REASONS = {
  CANCELLED: "cancelled",
  FORBIDDEN: "forbidden",
  RATE_LIMITED: "rateLimited",
  TECHNICAL: "technical",
} as const;

export type ScaLoginErrorReason = ObjectValuesAsTypes<
  typeof SCA_LOGIN_ERROR_REASONS
>;

export const SCA_LOGIN_STAGES = {
  INITIALIZE: "initialize",
  WEBAUTHN: "webauthn",
  FINALIZE: "finalize",
} as const;

export type ScaLoginStage = ObjectValuesAsTypes<typeof SCA_LOGIN_STAGES>;

export class ScaLoginError extends Error {
  public readonly reason: ScaLoginErrorReason;

  public readonly stage: ScaLoginStage;

  public constructor(reason: ScaLoginErrorReason, stage: ScaLoginStage) {
    super(`SCA login failed on ${stage} with reason ${reason}`);

    this.name = "ScaLoginError";
    this.reason = reason;
    this.stage = stage;
  }
}
